import { IBenefit, IFlexibleField, INonStandard } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer, ITransformContext } from "./IJsonTransformer";

export class DeprecateFieldsTransformer extends BaseJsonTransformer {
    async transformBenefit(benefit: IBenefit): Promise<boolean | void> {
        this.removeFields(benefit.fields);   
    }

    async transformNonStandard(nonStandard: INonStandard, context: ITransformContext): Promise<boolean | void> {
        this.removeFields(nonStandard.fields);
    }

    private removeFields(fields: IFlexibleField[]) {
        const n = fields.length;
        for (let i = n - 1; i >= 0; i--) {
            const field = fields[i];
            
            // William's Custom Field ...
            if (field.configRef.id === 'cd602b89-3e84-ec11-8d21-000d3a5cce58') {
                fields.splice(i, 1);
            }

        }  
    }
}